module.exports = __webpack_public_path__ + "static/media/nodejs.8aa5404d.png";